<script>
export default {
    data() {
        return {
            src: ''
        };
    },
    mounted() {
        const search = window.location.search
        let params = {}
        if (search !== '') {
            //如果search不是空字符串
            search
                .slice(1)
                .split('&')
                .forEach(val => {
                    const arr = val.split('=') //将当前元素值按=切割，保存在arr中
                    params[arr[0]] = arr[1] //向params中添加一个元素,属性名为arr[0],值为arr[1]
                })
        }
        this.src = decodeURIComponent(params.src)
    }
}
</script>

<template>
    <embed :src="this.src" type="application/pdf" width="100%" height="95%">
</template>

<style scoped>

</style>